const APP_PAGES = new Set([
  'about',
  'contact',
  'cookies',
  'dashboard',
  'faq',
  'features',
  'founder',
  'help',
  'pricing',
  'privacy',
  'question-bank',
  'resume-analyzer',
  'sitemap',
  'terms',
  'verify',
]);

function normalizePathname(pathname = '/') {
  const trimmedPath = pathname.replace(/\/+$/, '');
  return trimmedPath || '/';
}

export function getLegacyPathFromHash(hash = '') {
  const cleanHash = hash.replace(/^#/, '').replace(/^\/+/, '');

  if (!cleanHash) {
    return '';
  }

  const segments = cleanHash.split('/').filter(Boolean);
  const [firstSegment, secondSegment] = segments;

  if (firstSegment === 'dashboard') {
    return `/dashboard/${secondSegment || 'interview'}/`;
  }

  if (firstSegment === 'verify') {
    return secondSegment ? `/verify/${secondSegment}/` : '/verify/';
  }

  if (!APP_PAGES.has(firstSegment)) {
    return '';
  }

  return `/${firstSegment}/`;
}

export function getCurrentPathname(locationObject = window.location) {
  return getLegacyPathFromHash(locationObject.hash) || normalizePathname(locationObject.pathname);
}

export function getCurrentPageFromLocation(locationObject = window.location) {
  const pathSegments = getCurrentPathname(locationObject).split('/').filter(Boolean);
  return pathSegments[0] || 'home';
}

export function getDashboardTabFromLocation(locationObject = window.location) {
  const pathSegments = getCurrentPathname(locationObject).split('/').filter(Boolean);

  if (pathSegments[0] !== 'dashboard') {
    return 'interview';
  }

  return pathSegments[1] || 'interview';
}

export function buildPagePath(page = 'home') {
  if (!page || page === 'home') {
    return '/';
  }

  return `/${page.replace(/^\/+|\/+$/g, '')}/`;
}

export function buildDashboardPath(tab = 'interview') {
  const normalizedTab = (tab || 'interview').replace(/^\/+|\/+$/g, '');
  return `/dashboard/${normalizedTab || 'interview'}/`;
}

export function isAppPath(path = '/') {
  const normalizedPath = normalizePathname(path);
  const pathSegments = normalizedPath.split('/').filter(Boolean);
  const firstSegment = pathSegments[0] || 'home';

  return firstSegment === 'home' || APP_PAGES.has(firstSegment);
}

export function navigateToPath(path = '/', { replace = false } = {}) {
  if (typeof window === 'undefined') {
    return;
  }

  const url = new URL(path, window.location.origin);
  const nextLocation = `${url.pathname}${url.search}${url.hash}`;
  const currentLocation = `${window.location.pathname}${window.location.search}${window.location.hash}`;

  if (nextLocation === currentLocation) {
    return;
  }

  window.history[replace ? 'replaceState' : 'pushState']({}, document.title, nextLocation);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function navigateToPage(page, options) {
  navigateToPath(buildPagePath(page), options);
}

export function navigateToDashboardTab(tab, options) {
  navigateToPath(buildDashboardPath(tab), options);
}

export function upgradeLegacyHashRoute() {
  if (typeof window === 'undefined') {
    return false;
  }

  const legacyPath = getLegacyPathFromHash(window.location.hash);

  if (!legacyPath) {
    return false;
  }

  navigateToPath(`${legacyPath}${window.location.search}`, { replace: true });
  return true;
}
